import React, { useState, useEffect, useRef } from 'react';
import QRCode from 'qrcode';

const QRCodeGenerator = () => {
  // 状态管理
  const [qrcodeData, setQrcodeData] = useState({
    size: '18cm',
    material: '紫水晶',
    price: '¥299'
  });
  const [qrCodeUrl, setQrCodeUrl] = useState('');
  const qrCodeRef = useRef(null);

  // 生成二维码
  const generateQRCode = React.useCallback(() => {
    const dataString = `手链信息：\n尺寸：${qrcodeData.size}\n材质：${qrcodeData.material}\n价格：${qrcodeData.price}`;
    
    QRCode.toDataURL(dataString, { width: 200, margin: 2 })  // 添加 margin 属性
      .then(url => {
        setQrCodeUrl(url);
      })
      .catch(err => {
        console.error('生成二维码失败:', err);
      });
  }, [qrcodeData]);

  // 处理输入变化
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setQrcodeData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // 保存二维码图片
  const saveQRCode = () => {
    if (qrCodeUrl) {
      const a = document.createElement('a');
      a.href = qrCodeUrl;
      a.download = '手链二维码.png';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  // 打印二维码
  const printQRCode = () => {
    if (qrCodeUrl && qrCodeRef.current) {
      const printWindow = window.open('', '_blank');
      printWindow.document.write(`
        <html>
          <head>
            <title>打印二维码</title>
            <style>
              body { display: flex; justify-content: center; align-items: center; height: 100vh; margin: 0; }
              .qrcode-container { text-align: center; }
              h2 { color: #6f42c1; margin-bottom: 20px; }
            </style>
          </head>
          <body>
            <div class="qrcode-container">
              <h2>手链二维码</h2>
              <img src="${qrCodeUrl}" alt="手链二维码" />
            </div>
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    }
  };

  // 初始化生成二维码
  useEffect(() => {
    generateQRCode();
  }, [generateQRCode]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-emerald-50 py-8">
      <div className="container mx-auto px-4">
        <h1 className="text-3xl font-bold text-center mb-8 text-emerald-800">
          手链二维码生成
        </h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* 输入区域 */}
          <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 border border-green-100">
            <h2 className="text-xl font-semibold mb-6 text-emerald-700 text-center">
              输入手链信息
            </h2>
            <div className="space-y-4">
              <div>
                <label className="block text-gray-700 mb-1">
                  手链尺寸
                </label>
                <input
                  type="text"
                  name="size"
                  value={qrcodeData.size}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 rounded-lg border border-green-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-gray-700 mb-1">
                  手链材质
                </label>
                <input
                  type="text"
                  name="material"
                  value={qrcodeData.material}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 rounded-lg border border-green-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                />
              </div>
              <div>
                <label className="block text-gray-700 mb-1">
                  手链价格
                </label>
                <input
                  type="text"
                  name="price"
                  value={qrcodeData.price}
                  onChange={handleInputChange}
                  className="w-full px-4 py-2 rounded-lg border border-green-200 focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-transparent"
                />
              </div>
              <button
                onClick={generateQRCode}
                className="w-full px-6 py-3 bg-gradient-to-r from-emerald-500 to-teal-500 text-white rounded-lg hover:from-emerald-600 hover:to-teal-600 transition-colors duration-200 font-medium"
              >
                生成二维码
              </button>
            </div>
          </div>

          {/* 二维码展示区域 */}
          <div className="bg-white rounded-xl shadow-lg p-6 md:p-8 border border-green-100 flex flex-col items-center justify-center">
            <h2 className="text-xl font-semibold mb-6 text-emerald-700 text-center">
              生成的二维码
            </h2>
            {qrCodeUrl && (
              <div className="mb-6" ref={qrCodeRef}>
                <img
                  src={qrCodeUrl}
                  alt="手链二维码"
                  className="shadow-md"
                />
              </div>
            )}
            <div className="flex gap-4">
              <button
                onClick={saveQRCode}
                className="px-6 py-3 bg-green-200 text-green-800 rounded-lg hover:bg-green-300 transition-colors duration-200 font-medium"
              >
                保存图片
              </button>
              <button
                onClick={printQRCode}
                className="px-6 py-3 bg-blue-200 text-blue-800 rounded-lg hover:bg-blue-300 transition-colors duration-200 font-medium"
              >
                打印二维码
              </button>
            </div>
            <div className="mt-6 text-gray-600 text-center">
              <p>将二维码用于线下展示或包装，方便顾客扫描了解手链信息</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QRCodeGenerator;